import { Star } from "lucide-react";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const reviews = [{
  text: "The pricing is incredibly competitive for the value we get. We've seen a 300% ROI since implementing planniFi."
}, {
  text: "Best investment we've made this year. The cost savings from better budget tracking alone paid for the subscription."
}, {
  text: "Affordable and powerful. planniFi delivers enterprise-level features at a price point that makes sense for growing businesses."
}, {
  text: "The annual plan is a no-brainer. We're saving thousands on media spend optimization while getting better results."
}, {
  text: "Worth every penny. The insights we get from planniFi have transformed how we allocate our marketing budget."
}, {
  text: "Incredibly cost-effective for the features provided. It's like having an entire analytics team at a fraction of the cost."
}];
const PricingReviews = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });
  return <section className="pt-8 bg-surface px-[6px] mx-[4px] py-[48px]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-charter text-center mb-8">
          Loved by marketing teams
        </h2>
        
        <div ref={ref} className="max-w-7xl mx-auto">
          <ScrollArea className="w-full whitespace-nowrap md:whitespace-normal" style={{
          "--thumb-size": "16.666%"
        } as React.CSSProperties}>
            <div className="flex md:grid md:grid-cols-3 gap-8 pb-6 md:pb-0 pr-8 md:pr-0">
              {reviews.map((review, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-sm border-2 border-primary/10 transform transition-all duration-500 min-w-[240px] md:min-w-0 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
              transitionDelay: `${index * 100}ms`
            }}>
                  <div className="flex mb-4">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />)}
                  </div>
                  <p className="text-primary/80 whitespace-normal">{review.text}</p>
                </div>)}
            </div>
            <ScrollBar orientation="horizontal" className="md:hidden h-1.5 bg-primary/5 rounded-full mt-6 hover:bg-primary/5" forceMount />
          </ScrollArea>
        </div>
      </div>
    </section>;
};
export default PricingReviews;